import React, { useState, useMemo } from 'react';
import { Close, Search } from '@material-ui/icons';
import { CircularProgress } from '@material-ui/core';
import {
  DrawerOverlay,
  DrawerContainer,
  DrawerHeader,
  DrawerTitle,
  DateTitle,
  DeliveryCount,
  HeaderActions,
  CloseButton,
  DrawerContent,
  DeliveryTable,
  TableCell,
  TableRow,
  DrawerHeaderRow,
  EmptyStateContainer,
  TableCellSubject,
} from './ReviewCampaignDrawer.styled';
import {
  SearchContainer,
  LoadingProgressContainer,
} from '../ReviewCampaign/ReviewCampaign.styled';
import ExportDeliveries from './ExportDeliveries';
import CalendarIcon from '../ReviewCampaign/CalendarIcon.png';

const ReviewCampaignDrawer = ({
  isOpen,
  onClose,
  deliveries,
  date,
  campaignName,
  loading = false,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter deliveries by search term
  const filteredDeliveries = useMemo(() => {
    if (!searchTerm) return deliveries;

    const term = searchTerm.toLowerCase();
    return deliveries.filter(
      delivery =>
        delivery.contactName.toLowerCase().includes(term) ||
        delivery.contactEmail.toLowerCase().includes(term) ||
        delivery.stageName.toLowerCase().includes(term) ||
        delivery.subject.toLowerCase().includes(term)
    );
  }, [deliveries, searchTerm]);

  if (!isOpen) {
    return null;
  }

  const formatDate = date => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <DrawerOverlay onClick={handleOverlayClick}>
      <DrawerContainer>
        <DrawerHeader>
          <DrawerHeaderRow>
            <CloseButton onClick={onClose}>
              <Close />
            </CloseButton>
            <HeaderActions>
              <SearchContainer>
                <SearchContainer.Icon>
                  <Search />
                </SearchContainer.Icon>
                <SearchContainer.Input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </SearchContainer>
              <ExportDeliveries
                deliveries={filteredDeliveries}
                campaignName={campaignName}
                date={date}
              />
            </HeaderActions>
          </DrawerHeaderRow>
          <DrawerHeaderRow>
            <DrawerTitle>
              <img
                src={CalendarIcon}
                alt="Calendar Icon"
                width="20"
                height="20"
              />
              <DateTitle>{formatDate(date)}</DateTitle>
            </DrawerTitle>
            {!loading && (
              <DeliveryCount>
                {filteredDeliveries.length} projected deliver
                {filteredDeliveries.length !== 1 ? 'ies' : 'y'}
              </DeliveryCount>
            )}
          </DrawerHeaderRow>
        </DrawerHeader>

        <DrawerContent>
          {loading ? (
            <LoadingProgressContainer>
              <CircularProgress size={24} />
              <div>Loading deliveries for {formatDate(date)}...</div>
            </LoadingProgressContainer>
          ) : (
            <DeliveryTable>
              {filteredDeliveries && filteredDeliveries.length > 0 ? (
                filteredDeliveries.map((delivery, index) => (
                  <TableRow key={delivery.id || index}>
                    <TableCell>{delivery.contactName}</TableCell>
                    <TableCell>{delivery.contactEmail}</TableCell>
                    <TableCell>{delivery.stageName}</TableCell>
                    <TableCellSubject>{delivery.subject}</TableCellSubject>
                  </TableRow>
                ))
              ) : (
                <EmptyStateContainer>
                  No deliveries found for {formatDate(date)}
                </EmptyStateContainer>
              )}
            </DeliveryTable>
          )}
        </DrawerContent>
      </DrawerContainer>
    </DrawerOverlay>
  );
};

export default ReviewCampaignDrawer;
